import * as actionType from "./affiliateActionType";

const initialState = {
    isLoading: false,
    isSaved:false,
    affiliates:[],
};

export const affiliateReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.UPDATE_AFFILIATE:
            return {
                ...state,
                isLoading: true,
                isSaved: false,
            };
        case actionType.UPDATE_AFFILIATE_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.UPDATE_AFFILIATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSaved: true,
            };
        case actionType.ADD_COUPON:
            return {
                ...state,
                isLoading: true,
                isSaved: false,
            };
        case actionType.ADD_COUPON_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.ADD_COUPON_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSaved: true,
            };
        case actionType.GET_AFFILIATE:
            return {
                ...state,
                isLoading: true,
                isSaved: false,
            };
        case actionType.GET_AFFILIATE_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.GET_AFFILIATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                affiliates: action?.payload?.data?.rows || [],
            };
        default:
            return state;
    }
}